// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"531":"fd0b9908","728":"01975c3b"}[chunkId] + ".chunk.js";
};